import dayjs from 'dayjs';

export const messageFormat = (data, field = 'type') => {
  // console.log('data', data);
  let Message = data.lastMessage || data.lastMessageVo || data;
  if (data.pdType == 'mail') {
    return '[邮件]';
  }
  if (data.pdType == 'readMail') {
    return '阅读了你的邮件';
  }

  if (Message[field] == 'message' || Message[field] == 'system') {
    return Message.content?.message;
  }
  if (Message[field] == 'wink') {
    return '👋 Winked';
  }
  if (Message[field] == 'giftLimit') {
    return '🎁可以送ta礼物了';
  }
  if (Message[field] == 'sendNewMessage') {
    return '可以发消息';
  }
  if (Message[field].indexOf('like') != -1) {
    let txt = '👍 Liked';
    if (Message[field].indexOf('post') != -1) {
      txt += ' a post';
    }
    if (Message[field].indexOf('photo') != -1) {
      txt += ' the photo';
    }
    return txt;
  }
  if (Message[field].indexOf('reply_newsfeed_post') != -1) {
    return '💬回复了帖子';
  }
  if (
    Message[field].indexOf('photo') != -1 ||
    Message[field].indexOf('image') != -1
  ) {
    return '[图片]';
  }
  if (Message[field].indexOf('video') != -1) {
    return '[视频]';
  }
  if (Message[field].indexOf('audio') != -1) {
    return '[音频]';
  }

  return Message[field];
};

export const formatTime = (dateString, timezoneOffset = 0) => {
  // 如果dateString是"1757396523"这种格式需要特殊处理成之前的格式，走之后的流程。不是的话保持原来的逻辑不变
  if (!dateString) {
    return '';
  }

  let targetTime;
  // 检查是否是纯数字时间戳格式（如"1757396523"）
  if (/^\d+$/.test(dateString)) {
    // 如果是纯数字，直接转换为时间戳（假设是秒级时间戳）
    targetTime = parseInt(dateString) * 1000;
  } else {
    // 否则按原来的逻辑处理
    targetTime = new Date(dateString).getTime();
  }

  // 应用时区偏移（小时转换为毫秒）
  targetTime = targetTime + timezoneOffset * 60 * 60 * 1000;

  const now = Date.now();
  const diffInSeconds = Math.floor((now - targetTime) / 1000); // 时间差（秒）

  let date = '';
  if (diffInSeconds < 60) {
    date = '刚刚';
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    date = `${minutes}分钟前`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    date = `${hours}小时前`;
  } else if (diffInSeconds < 2592000) {
    // 30天内
    const days = Math.floor(diffInSeconds / 86400);
    date = `${days}天前`;
  } else if (diffInSeconds < 31536000) {
    // 1年内
    const months = Math.floor(diffInSeconds / 2592000);
    date = `${months}个月前`;
  } else {
    const years = Math.floor(diffInSeconds / 31536000);
    date = `${years}年前`;
  }
  return date;
};
